import { useGetItineraryDataQuery } from '@/src/api/rtkQuery/itineraryApi'
import { Fare } from '@/src/types/itinerary'
import useGetItineraryId from '../../useGetItineraryId'

const useSmbMandatoryCheck = () => {
    const itineraryId = useGetItineraryId()
    const { fareFamilyFares, smbMandatoryFareMap, initialFares } = useGetItineraryDataQuery(
        {
            itineraryId
        },
        {
            selectFromResult: ({ data }) => ({
                fareFamilyFares: data?.fareFamilyFares || [],
                meta: data?.meta,
                smbMandatoryFareMap: data?.smbMandatoryFareMap || {},
                initialFares: data?.itineraryData?.fares || []
            })
        }
    )
    const faresToCheck = fareFamilyFares.length ? fareFamilyFares : initialFares
    const selectedFareFamily = faresToCheck.find((fare: Fare) => fare.selected)
    const ctBrandName = selectedFareFamily?.fareGroupInformation?.ctBrandName || "REGULAR"
    const selectedFareMandatorySegmentMap = smbMandatoryFareMap[ctBrandName] || {}

    let isSeatMandatory = false
    let isMealMandatory = false

    if (smbMandatoryFareMap[ctBrandName]) {
        isSeatMandatory = Object.values(selectedFareMandatorySegmentMap).some(value => value.seat)
        isMealMandatory = Object.values(selectedFareMandatorySegmentMap).some(value => value.meal)
    }

    return {
        isSeatMandatory,
        isMealMandatory,
        selectedFareMandatorySegmentMap
    }
}

export default useSmbMandatoryCheck
